import axios from 'axios';
import Vue from "vue";
import VueRouter from "../router";

var token = window.sessionStorage.getItem('token')
//console.log('axios'+token);
export const HTTP = axios.create({

  baseURL: process.env.HOST_API,
  authorization: `Bearer ${token}`


})
HTTP.defaults.headers.common['authorization'] = `Bearer ${token}`;
// Add a response interceptor
HTTP.interceptors.response.use(function (response) {
  // Do something with response data

  return response;
}, function (error) {

  if (error.response.data.error == 'token_expired') {

    VueRouter.push({
      name: 'Login'
    })
  }
  // Do something with response error
  return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./src/services/http.axios.js